import { render, staticRenderFns } from "./menuMobile.vue?vue&type=template&id=a63142bc"
import script from "./menuMobile.vue?vue&type=script&lang=js"
export * from "./menuMobile.vue?vue&type=script&lang=js"
import style0 from "./menuMobile.vue?vue&type=style&index=0&id=a63142bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports